module.exports = __webpack_public_path__ + "static/media/user-secret.b6a54582.svg";